import React, { Component } from 'react';
import './Accordion.css';
import Panel2 from '../Panel2/Panel2';

class Accordion extends Component {

    constructor(props) {
        super(props);
        this.state = {
            panelIdx: -1,
            collapsedHeight: 0,
            expandedMax: 0,
            aniId: -1

        };

        this.panels = [];
        this.panelHeights = [];
        this.isExpanded = false;

        this.mobileHeight = 700;

    }

    componentDidMount() {
        this.setState({collapsedHeight: this.accordion.scrollHeight});
    }

    componentWillUnmount() {

    }

    componentDidUpdate() {

    };



    handleClick = (type) => {
       /* //console.log(("click footer - type: " + type);
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(0, type, "footer");
        }*/
    };

    onPanelHeight = (idx,height) => {
        this.panelHeights[idx] = height;
    }

    onPanelState = (idx,isExpanded) => {
         var headerHeight = 200;

         var maxHeight = window.innerHeight - headerHeight - this.state.collapsedHeight;

         console.log('Accordion - onPanelState: ', isExpanded);

        this.isExpanded = isExpanded;

        if (isExpanded) {
            this.setState({panelIdx: -1, expandedMax: maxHeight});
            if ( typeof this.props.onCollapse=== 'function') {
                this.props.onCollapse();
            }

        } else {

            if (window.innerHeight < this.mobileHeight) {
                if (window.innerHeight < window.innerWidth) {
                    maxHeight = window.innerHeight*1.5 - headerHeight - this.panelHeights[idx];
                } else {
                    maxHeight = window.innerHeight - headerHeight - this.panelHeights[idx];
                }

            } else {
                maxHeight = window.innerHeight - headerHeight - this.state.collapsedHeight;
            }

            this.setState({panelIdx: idx, expandedMax: maxHeight});
            if (typeof this.props.onExpand === 'function') {
                this.props.onExpand();
            }

            // Reload iframe manager
            setTimeout(() => {
                window.InitializeIFrameManager();
            }, 500);

        }

    }


  render() {
    var k = -1;

    if (this.props.panels === undefined) return null;

    var panelsOnStage = [];
    for (var i=0; i<this.props.panels.length; i++) {
        var el = this.props.panels[i];
        if (window.innerHeight < this.mobileHeight && this.state.panelIdx !== -1) {
            if (this.state.panelIdx === i) {
                el.isVisible = true;
            } else {
                el.isVisible = false;
            }
        } else {
            el.isVisible = true;
        }
        panelsOnStage.push(el);
    }

    return (
      <div className="Accordion" ref={(d) => { this.accordion = d; }}>
          {
          this.panels = panelsOnStage.map((panel) =>
          <div key={(k++).toString()} className="col-md-12 col-sm-12">
              <Panel2 onHeight={this.onPanelHeight} isVisible={panel.isVisible} maxHeight={this.state.expandedMax} onState={this.onPanelState} idx={k} isExpanded={(k === this.state.panelIdx)} headline={panel.headline} text_short={panel.text_short} text={panel.text} onChange={this.onPanelState}/>
          </div>
          )}
      </div>
    );
  }
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/Accordion/Accordion.js